/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance"; 
import defaultImage from "assets/img/image_placeholder.jpg";
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';

import defaultAvatar from "assets/img/placeholder.jpg";

// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";

import { Text,rem, Image, SimpleGrid } from '@mantine/core';
const useStyles = makeStyles(styles);

export default function KYCDetailPage() {
  let fileInput = React.createRef();

  const [formValues, setFormValues] = React.useState({
    lotteryName: "",
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    firstDrawPrize: 0,
    secondDrawPrize: 0,
    thirdDrawPrize: 0,
    instruction: "dkjfsajkf",
    maxRpmLotteryWheel: 0,
    decelarationOfLotteryWheel: 20,
    maxNumOfTickets: 0,
    status: "",
    image:''
  });
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const [avatar, setAvatar]= React.useState(true)
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [files, setFiles] = React.useState([]);

  const previews = files.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    console.log(files);
    return (
      <Image
        key={index}
        src={imageUrl}
        imageProps={{ onLoad: () => URL.revokeObjectURL(imageUrl) }}
      />
    );
    
  });

const handleSubmitForm = async () => {
            const token = localStorage.getItem("token");
            const formData = new FormData();
        
            for (const key in formValues) {
              formData.append(key, formValues[key]);
            }
            formData.append("donationImage", selectedFile);
            const newFormValue= Object.assign(formValues,{"image":imagePreviewUrl});
            axios.post(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery`,
            newFormValue,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Access-Control-Allow-Origin": "*",
                    }
                }
    
            ).then((res) => {
                console.log(res);
                alert("Lottery has been Created!!");
            })
                .catch((err) => {
                    console.warn(err);
                    alert(err);
                })
        }
  const handleLotteryDateTimeChange = (event) => {
    const date = new Date(event._d);
    setSelectedDate(date.toISOString().split("T")[0]); // Extract date in yyyy-mm-dd format
    setSelectedTime(date.toISOString().split("T")[1].substring(0, 5)); // Extract time in hh:mm format
    console.log(selectedDate, selectedTime);
    setFormValues({
      ...formValues,
      lotteryDrawDate: date.toISOString(),
      lotteryDrawTime: date.toISOString()
    });
    console.log(formValues);
  };
  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Player Information</h4>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
             
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="First Name *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                  readonly: true,
                }}
                inputProps={{
                  readonly:true,
                  disabled:true
                }}
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="Last Name *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
              
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="Nick Name *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
              
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="Email Address *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="Country"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <CustomInput
                labelText="Comments"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
              />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                <Dropzone
                onDrop={setFiles}
                accept={IMAGE_MIME_TYPE}
                sx={(theme) => ({
                  minHeight: rem(120),
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: 0,
                  backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
          
                  '&[data-accept]': {
                    color: theme.white,
                    backgroundColor: theme.colors.blue[6],
                  },
          
                  '&[data-reject]': {
                    color: theme.white,
                    backgroundColor: theme.colors.red[6],
                  },
                })}
              >
                <Text align="center">Drop images here</Text>
              </Dropzone>

              <SimpleGrid
              cols={4}
              breakpoints={[{ maxWidth: 'sm', cols: 1 }]}
              mt={previews.length > 0 ? 'xl' : 0}
            >
              {previews}
            </SimpleGrid>
                </GridItem> 
              </GridContainer>

              <Button
                color="rose"
                className={classes.registerButton}
                onClick={handleSubmitForm}
              >
                Approve
              </Button>
              <Button
              color="rose"
              className={classes.registerButton}
              onClick={handleSubmitForm}
            >
              Reject
            </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
